import React from 'react';
import { useSelector } from 'react-redux';
import WarningIcon from '@material-ui/icons/Warning';
import classNames from 'clsx';

import { Message } from 'app/shared/interfaces/Message.interface';
import { MessagesEnum } from 'app/shared/enums';
import { makeGetMessagesForFormRow } from 'app/store/data/formsConfig';
import { RootState } from 'app/store/rootReducer';
import { Alert } from 'app/components/Alert';
import { selectIsFormMicroCenterActive } from 'app/store/selectors/selectIsFormMicroCenterActive';
import { getSuffixFromMessageKey } from 'app/services/validation.service';

import { RowMessagesProps } from './RowMessages.interface';
import { useStyles } from './RowMessages.styles';

const iconsConfig: Partial<Record<MessagesEnum, JSX.Element>> = {
  [MessagesEnum.YoungDriverSameAsOwner]: <WarningIcon />,
  [MessagesEnum.TypoInEmailDomain]: <></>,
};

function RowMessages(props: RowMessagesProps) {
  const { formName, questionKey, position } = props;

  const classes = useStyles();
  const getMessagesForFormRow = makeGetMessagesForFormRow();
  const messages = useSelector((state: RootState) =>
    getMessagesForFormRow(state, formName, questionKey)
  );
  const isFormMicroCenterActive = useSelector(selectIsFormMicroCenterActive);

  const filterMessageByPosition = ({
    position: messagePosition = 'bottom',
  }: Message) => messagePosition === position;

  const renderMessage = ({ key, type, content, htmlContent }: Message) => {
    const baseKey = getSuffixFromMessageKey(key) as MessagesEnum;

    return (
      <div
        key={key}
        className={classNames(classes.validationMessage, {
          [classes.validationMessageCepikAbTest]: isFormMicroCenterActive,
        })}
      >
        <Alert
          text={htmlContent || content}
          type={type}
          icon={htmlContent ? false : iconsConfig[baseKey]}
          className={classNames({
            [classes.alertTop]: position === 'top',
          })}
        />
      </div>
    );
  };

  return messages ? (
    <>{messages.filter(filterMessageByPosition).map(renderMessage)}</>
  ) : null;
}

export default React.memo(RowMessages);
